(function () {
	'use strict';

	const initDOM = () => {
		// Helper to update the subscribed variations array in DOM attribute
		const getSubscribedVariations = ($wrapper) => {
			try {
				return JSON.parse($wrapper.attr('data-subscribed-variations') || '[]');
			} catch (e) {
				return [];
			}
		};

		const setSubscribedVariations = ($wrapper, arr) => {
			$wrapper.attr('data-subscribed-variations', JSON.stringify(arr));
		};

		// Helper to toggle visibility of subscribe vs unsubscribe containers
		const updateUIState = ($wrapper, variationId) => {
			const arr = getSubscribedVariations($wrapper);
			const isSubscribed = arr.includes(parseInt(variationId));

			const $subscribeCon = $wrapper.find('.negarshop-waiting-list-subscribe-container');
			const $unsubscribeCon = $wrapper.find('.negarshop-waiting-list-unsubscribe-container');

			if (isSubscribed) {
				$subscribeCon.hide();
				$unsubscribeCon.show();
			} else {
				$subscribeCon.show();
				$unsubscribeCon.hide();
			}
		};

		// Handle waiting list form submission (Subscribe)
		window.jQuery(document).on('submit', '.negarshop-waiting-list-form', function (e) {
			e.preventDefault();

			const $form = window.jQuery(this);
			const $wrapper = $form.closest('.negarshop-waiting-list-wrapper');
			const $message = $wrapper.find('.negarshop-waiting-list-message');
			const $btn = $form.find('button[type="submit"]');
			const $spinner = $btn.find('.spinner-border');

			const email = $form.find('input[name="email"]').val();
			const productId = $form.find('input[name="product_id"]').val();
			const variationId = $form.find('input[name="variation_id"]').val();
			const nonce = $form.find('input[name="waiting_list_nonce"]').val();

			$btn.prop('disabled', true);
			$spinner.removeClass('d-none');
			$message.hide().removeClass('text-success text-danger alert-success alert-danger');

			const ajaxUrl = (window.NS_OBJ && window.NS_OBJ.ajax_url) ? window.NS_OBJ.ajax_url : (window.location.origin + '/wp-admin/admin-ajax.php');

			window.jQuery.ajax({
				url: ajaxUrl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'negarshop_waiting_list_subscribe',
					email: email,
					product_id: productId,
					variation_id: variationId,
					security: nonce
				},
				success: function (response) {
					$spinner.addClass('d-none');
					$btn.prop('disabled', false);

					if (response.success) {
						$message.removeClass('alert-danger').addClass('alert-success').html(response.data.message).show();
						$form.find('input[name="email"]').val('');

						// Update state
						const arr = getSubscribedVariations($wrapper);
						const vId = parseInt(variationId);
						if (!arr.includes(vId)) {
							arr.push(vId);
							setSubscribedVariations($wrapper, arr);
						}
						updateUIState($wrapper, variationId);
					} else {
						$message.removeClass('alert-success').addClass('alert-danger').html(response.data.message).show();
					}
				},
				error: function () {
					$spinner.addClass('d-none');
					$btn.prop('disabled', false);
					$message.removeClass('alert-success').addClass('alert-danger').html('خطایی در ارتباط با سرور رخ داد. لطفا مجددا تلاش کنید.').show();
				}
			});
		});

		// Handle waiting list unsubscribe form submission (Unsubscribe)
		window.jQuery(document).on('submit', '.negarshop-waiting-list-unsubscribe-form', function (e) {
			e.preventDefault();

			const $form = window.jQuery(this);
			const $wrapper = $form.closest('.negarshop-waiting-list-wrapper');
			const $message = $wrapper.find('.negarshop-waiting-list-message');
			const $btn = $form.find('button[type="submit"]');
			const $spinner = $btn.find('.spinner-border');

			const productId = $form.find('input[name="product_id"]').val();
			const variationId = $form.find('input[name="variation_id"]').val();
			const nonce = $form.find('input[name="waiting_list_nonce"]').val();

			$btn.prop('disabled', true);
			$spinner.removeClass('d-none');
			$message.hide().removeClass('text-success text-danger alert-success alert-danger');

			const ajaxUrl = (window.NS_OBJ && window.NS_OBJ.ajax_url) ? window.NS_OBJ.ajax_url : (window.location.origin + '/wp-admin/admin-ajax.php');

			window.jQuery.ajax({
				url: ajaxUrl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'negarshop_waiting_list_unsubscribe',
					product_id: productId,
					variation_id: variationId,
					security: nonce
				},
				success: function (response) {
					$spinner.addClass('d-none');
					$btn.prop('disabled', false);

					if (response.success) {
						$message.removeClass('alert-danger').addClass('alert-success').html(response.data.message).show();

						// Update state
						const arr = getSubscribedVariations($wrapper);
						const vId = parseInt(variationId);
						const index = arr.indexOf(vId);
						if (index > -1) {
							arr.splice(index, 1);
							setSubscribedVariations($wrapper, arr);
						}
						updateUIState($wrapper, variationId);
					} else {
						$message.removeClass('alert-success').addClass('alert-danger').html(response.data.message).show();
					}
				},
				error: function () {
					$spinner.addClass('d-none');
					$btn.prop('disabled', false);
					$message.removeClass('alert-success').addClass('alert-danger').html('خطایی در ارتباط با سرور رخ داد. لطفا مجددا تلاش کنید.').show();
				}
			});
		});

		// Dynamic handling of out-of-stock variations
		if (window.jQuery) {
			window.jQuery(document).on('found_variation', 'form.variations_form', function (event, variation) {
				const $wrapper = window.jQuery('.negarshop-waiting-list-wrapper');
				if ($wrapper.length) {
					// Clear any previous submit message
					$wrapper.find('.negarshop-waiting-list-message').hide().removeClass('alert-success alert-danger');
					
					if (variation && !variation.is_in_stock) {
						$wrapper.find('.negarshop-waiting-list-variation-id').val(variation.variation_id);
						updateUIState($wrapper, variation.variation_id);
						$wrapper.show();
					} else {
						$wrapper.hide();
					}
				}
			});

			window.jQuery(document).on('reset_data', 'form.variations_form', function () {
				const $wrapper = window.jQuery('.negarshop-waiting-list-wrapper');
				if ($wrapper.length) {
					$wrapper.find('.negarshop-waiting-list-message').hide().removeClass('alert-success alert-danger');
					
					// If the parent product itself is out of stock, keep showing, otherwise hide
					const parentIsOutOfStock = window.jQuery('.default-product-single').hasClass('outofstock');
					if (parentIsOutOfStock) {
						$wrapper.find('.negarshop-waiting-list-variation-id').val(0);
						updateUIState($wrapper, 0);
						$wrapper.show();
					} else {
						$wrapper.hide();
					}
				}
			});
		}

		// Handle waiting list item removal from My Account waiting-list tab
		window.jQuery(document).on('click', '.ns-waiting-list-remove-btn', function (e) {
			e.preventDefault();

			const $btn = window.jQuery(this);
			const productId = $btn.data('product-id');
			const variationId = $btn.data('variation-id');
			const nonce = $btn.closest('.negarshop-waiting-list-container').attr('data-nonce');
			const $row = $btn.closest('tr');

			if (!productId) return;

			if (!confirm('آیا مطمئن هستید که می‌خواهید این محصول را از لیست انتظار حذف کنید؟')) {
				return;
			}

			$btn.prop('disabled', true);
			$btn.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

			const ajaxUrl = (window.NS_OBJ && window.NS_OBJ.ajax_url) ? window.NS_OBJ.ajax_url : (window.location.origin + '/wp-admin/admin-ajax.php');

			window.jQuery.ajax({
				url: ajaxUrl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'negarshop_waiting_list_unsubscribe',
					product_id: productId,
					variation_id: variationId,
					security: nonce
				},
				success: function (response) {
					if (response.success) {
						$row.fadeOut(400, function () {
							$row.remove();
							const $tbody = window.jQuery('.negarshop-waiting-list-container table tbody');
							if ($tbody.children('tr').length === 0) {
								window.location.reload();
							}
						});
					} else {
						alert(response.data.message || 'خطایی رخ داد.');
						$btn.prop('disabled', false).html('<i class="fi fi-br-trash"></i>');
					}
				},
				error: function () {
					alert('خطایی در ارتباط با سرور رخ داد. لطفا مجددا تلاش کنید.');
					$btn.prop('disabled', false).html('<i class="fi fi-br-trash"></i>');
				}
			});
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initDOM);
	} else {
		initDOM();
	}
})();
